import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme, { margin: string }>(theme => ({
  // classes for CSSTransition
  enter: {
    margin: 0,
    maxHeight: 0,
    opacity: 0,
  },
  enterActive: {
    margin: props => (props.margin ? props.margin : theme.spacing(2, 0, 0, 0)),
    maxHeight: theme.spacing(4),
    opacity: 1,
    transition: 'opacity 0.3s ease, max-height 0.3s ease, margin 0.3s ease',
  },
  enterDone: {
    margin: props => (props.margin ? props.margin : theme.spacing(2, 0, 0, 0)),
  },
  exit: {
    margin: 0,
    maxHeight: 0,
    opacity: 0,
    transition: 'opacity 0.3s ease, max-height 0.3s ease, margin 0.3s ease',
  },
}));

export default useStyles;
